import { turboproApiLista } from '@/api/turbopro';
import type { HistoricoSolicitacaoApi, ListaHistoricoSolicitacoesResponse } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listaHistoricoSolicitacoesApi(): Promise<ListaHistoricoSolicitacoesResponse> {
  const resposta = await turboproApiLista<HistoricoSolicitacaoApi>(
    'Relatorios/ListaHistoricoSolicitacoes',
    { headers: getRelatoriosHeaders() }
  );
  return { data: resposta.data ?? [], totalItens: resposta.totalItens };
}
